import type { SxProps, Theme } from '@mui/material/styles';

export const styles = {
    layout: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        px: 3,
    },
    link: {
        color: 'text.secondary',
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ml: 'auto',
    },
} satisfies Record<string, SxProps<Theme>>;
